// v0.6.12 (A2-37, operator decision 2026-10-02: "show, don't block").
//
// A reconciliation ADVISORY is a legal fact that needs no action but
// must be visible: an amount this country's form has no box for (a
// reverse-charge supply by a non-established supplier in PT, DK, CZ
// and HU — the buyer accounts for the VAT). It used to refuse to file
// in two countries and pass silently in the other two. Now all four
// render here: one line per notice, the amount, and the long text
// behind an ⓘ — never in the rose "Action required" banner, and
// never touching ready_to_file.
import React from "react";
import { getRuleCopy } from "../../lib/ruleCopy";
import { InfoCircle } from "../InfoCircle";
import { useTranslation } from "react-i18next";

const fmtAmount = (raw) => {
  const n = Number(raw);
  if (!Number.isFinite(n)) return raw;
  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  }).format(n);
};

export const AdvisoryNotices = ({ advisories }) => {
  const { t } = useTranslation();
  if (!advisories || advisories.length === 0) return null;
  return (
    <section
      data-testid="reconciliation-advisories"
      aria-label={t("ui.country_return.advisories_aria", { defaultValue: "Notes on this return" })}
      className="text-sm bg-amber-50 dark:bg-amber-950/30 border border-l-4 border-amber-400 rounded-lg p-3 mb-4 text-amber-950 dark:text-amber-100"
    >
      <ul className="space-y-1.5">
        {advisories.map((a) => {
          const copy = getRuleCopy(a.name, a.description || a.error);
          const amount = (a.offenders || [])[0]?.excluded_net;
          return (
            <li
              key={a.name}
              data-testid={`advisory-${a.name}`}
              className="flex items-start gap-2 min-w-0"
            >
              <span className="font-semibold">{copy.headline}</span>
              {amount != null && (
                <span
                  className="tabular-nums whitespace-nowrap"
                  data-testid={`advisory-amount-${a.name}`}
                >
                  {fmtAmount(amount)}
                </span>
              )}
              <InfoCircle testid={`advisory-info-${a.name}`}>
                {/* i18n-ignore: rule copy comes from lib/ruleCopy */}<p>{copy.fix}</p>
                {/* i18n-ignore: backend error text */}<p className="mt-2 opacity-80">{a.error}</p>
              </InfoCircle>
            </li>
          );
        })}
      </ul>
    </section>
  );
};
